export default __webpack_public_path__ + "1e124b61ef337efa1d00c6690f9deaf9.svg";